<template> 

  <div class="container pt-4 mb-5">
     
    <div>
      
      <div class="small text-right">    
        Stan konta: <B>{{ videoCredits }}</B> kredytów | <A href="" target="_blank">+ Doładuj</A>
      </div>
      
       

      <b-row align-v="top">

        <b-col lg="7">

          <b-row align-v="center">
  
            <b-col lg="12">
    
              

              <div class="mt-4">

                <div class="mt-3" v-if="windowImageGeneration">

                  <label>Wygeneruj obraz:</label>

                  <b-input-group>

                    <img src="" ref="previewImg"/>

                    <b-form-input v-model="imagePrompt" size="lg" ref="imagePrompt" placeholder="Różowy koń na polanie"></b-form-input>

                    <b-input-group-append>
                        
                        <b-button variant="outline-success" @click="triggerGenerateImage" ref="triggerGenerateImage">
                        <span class="material-symbols-outlined align-middle">
                          photo
                        </span>
                        Stwórz
                        </b-button>
    
                    </b-input-group-append>

                  </b-input-group>

                  <div class="mt-2" v-if="isAiGenImg">
                    <span class="material-symbols-outlined align-middle rotating">
                     rotate_right
                    </span> Trwa generowanie obrazu. Proszę czekać...
                  </div>
                  
                  <hr/>
                </div>

                <div class="mt-3">

                  <label>Obraz startowy:</label>

                  <b-input-group>

                  <b-input-group-prepend> 
                    <img :src="imageUrl" style="max-height: 48px;
                        max-width: 48px;
                        border-radius: 5px;
                        margin-right: 5px; cursor: pointer;" v-if="imageUrl && validateImageUrl(imageUrl)" @click="showImagePreview = !showImagePreview"/>
                  </b-input-group-prepend>
                    <b-form-input v-model="imageUrl" size="lg" ref="imageUrl" placeholder="https://adres.pl/plik.jpg"></b-form-input>
                    
                    <b-input-group-append>
                      
                        <b-button variant="outline-success" @click="triggerFileUpload">
                          <span class="material-symbols-outlined align-middle">
                            file_upload
                          </span>
                          Z pliku
                        </b-button>
                        <input type="file" ref="fileInput" style="display: none;" @change="handleFileUpload" />  

                      

                      <b-button variant="outline-primary" @click="windowImageGeneration = !windowImageGeneration">
                        <span class="material-symbols-outlined align-middle">
                          bolt
                        </span>
                        Generuj z AI
                      </b-button>
                        
                    </b-input-group-append>

                  </b-input-group>

                    <div class="d-flex justify-content-center mt-2">
                      <span class="material-symbols-outlined">
                        keyboard_arrow_down
                      </span>
                    </div>

                </div>
          

                <div class="" v-if="showImagePreview && imageUrl">

                  <img :src="imageUrl"  
                    style="max-height: 200px;
                       max-width: 200px;
                       border-radius: 5px;
                       margin-right: 5px;" 
                    v-if="validateImageUrl(imageUrl)" />

                  <div class="small" 
                     style="display: inline-block; margin-left: 10px; vertical-align: top; cursor: pointer;" 
                     @click="imageUrl = ''">
                    <span class="material-symbols-outlined align-middle">
                    close
                    </span> Usuń
                  </div>

                </div>


                <div class="">

                  <label>Wpisz prompt do filmu:</label>

                  <b-input-group>

                    <b-form-input v-model="prompt" size="lg" ref="prompt" placeholder=""></b-form-input>
                    
                  </b-input-group>
    
                </div>


                <div class="d-flex justify-content-center mt-2">
                      <span class="material-symbols-outlined">
                        keyboard_arrow_down
                      </span>
                    </div>


              </div>

            </b-col>


            <b-col lg="6">

              <div class="mt-3">

                <label>Wybierz czas trwania filmu:</label>

                <b-input-group>

                  <b-form-select v-model="duration" ref="duration" :options="durations"></b-form-select>

                </b-input-group>

              </div>

            </b-col>

            <b-col lg="6">

              <div class="mt-3">

                <label>Wybierz proporcje filmu:</label>

                <b-input-group>

                  <b-form-select v-model="ratio" ref="ratio" :options="ratios"></b-form-select>

                </b-input-group>

              </div>

            </b-col>



            <b-col lg="12">

              <b-card class="mt-3">

                <label style="cursor: pointer;" @click="showAdditSett = !showAdditSett">Dodatkowe ustawienia <span class="material-symbols-outlined align-middle">
                  arrow_drop_down
                  </span> </label>

                <div v-if="showAdditSett" class="mt-2">

                  <div class="ml-3 mt-3">

                    <label class="small">Wybierz styl kamery:</label>

                    <b-input-group>

                      <b-form-select v-model="selectedCameraStyles" ref="selectedCameraStyles" :options="cameraStyles"></b-form-select>

                    </b-input-group>

                  </div>

                  <div class="ml-3 mt-3">

                    <label class="small">Wybierz styl oświetlenia:</label>

                    <b-input-group>

                      <b-form-select v-model="selectedLightStyles" ref="selectedLightStyles" :options="lightStyles"></b-form-select>

                    </b-input-group>

                  </div>
      
                  <div class="ml-3 mt-3">

                    <label class="small">Wybierz ruch kamery:</label>

                    <b-input-group>

                      <b-form-select v-model="selectedCameraMovments" ref="selectedCameraMovments" :options="cameraMovments"></b-form-select>

                    </b-input-group>

                  </div>

                  <div class="ml-3 mt-3">

                    <label class="small">Wybierz styl transformacji:</label>

                    <b-input-group>

                      <b-form-select v-model="selectedTransformsStyles" ref="selectedTransformsStyles" :options="transformsStyles"></b-form-select>

                    </b-input-group>

                  </div>

                  <div class="ml-3 mt-3">

                    <label class="small">Wybierz styl filmu:</label>

                    <b-input-group>

                      <b-form-select v-model="selectedMovieStyles" ref="selectedMovieStyles" :options="movieStyles"></b-form-select>

                    </b-input-group>

                  </div>

                </div>
                  
              </b-card>

          </b-col>

        </b-row>
    
        <hr/>

        <b-row align-v="center" class="mt-2" style="min-height: 40px;">

         
          <b-col lg="12" class="small"> 
            Koszt wygenerowania: {{ duration * 5 }} kredytów.<br/>
            Zapoznaj się z <A href="https://docs.funnelstar.io/warunki-aplikacji-video" target="_blank">zasadami korzystania</A> z aplikacji.
          </b-col>

          <b-col lg="6">

            <div class="mt-2" v-if="isAiGenVideo">
              <span class="material-symbols-outlined align-middle rotating">
              rotate_right
              </span> Trwa generowanie video...
            </div>

          </b-col>

          <b-col lg="6">
          
            <b-button variant="outline-success mr-1" ref="generatePost" @click="generateFinish()" class="mt-3 float-right" v-if="(videoCredits >= (duration * 5))">
              <span class="material-symbols-outlined align-middle">
                bolt
              </span>
              Generuj
            </b-button> 

            <b-button variant="outline-success mr-1" class="mt-3 float-right" v-if="(videoCredits < (duration * 5))">
              <span class="material-symbols-outlined align-middle">
                add
              </span>
              Doładuj konto
            </b-button> 
            


          </b-col>

        </b-row>
 
      </b-col>

      <b-col lg="5">

        <div v-if="videoUrl" class="mt-4">

          <label>Wygenerowane video:</label>

          <video :src="videoUrl" controls class="mt-3" style="max-height: 100%; max-width: 100%; border-radius: 5px;" autoplay></video>
                  
        </div>

        <div v-if="videoList" class="mt-4">

          <label>Lista video:</label>
     
           <b-list-group>
            
            <b-list-group-item 
              v-for="(video, index) in videoList" 
              :key="index" 
              @click="videoUrl = video.video_url"
              class="small"
              :class="{ 'disabled': video.status !== 'ready', 'bold': (videoUrl !== '' && (videoUrl === video.video_url)) }"
              style="cursor: pointer;"
            >
            <i class="material-symbols-outlined align-middle mr-2 small rotating" v-if="video.status === 'queue'">rotate_right</i>
            <i class="material-symbols-outlined align-middle mr-2 small" v-if="video.status === 'ready'">check</i>
            <i class="material-symbols-outlined align-middle mr-2 small" v-if="video.status === 'failed'">close</i>
            
              {{ video.task_id }}
              
              <a :href="video.video_url" target="_blank" class="ml-2 text-primary small float-right" v-if="video.status === 'ready'">
                
                <i class="material-symbols-outlined align-middle mr-2 small">download</i>
                
              </a>

            </b-list-group-item>
           
          </b-list-group>

        </div>

        

      </b-col>
    
    </b-row>

    </div>
 
    

    
  </div>

</template>

<script>

  export default {
    name: 'AppArticleSEOIdeas',
    components: {
    },
    data() {
      return {
        result: "",
        result2: "",
        selectedText: '',
        windowImageGeneration: false,
        showAdditSett: false,
        isAiGenImg: false,
        isAiGenVideo: false,
        imagePrompt: "",
        query: "",
        prompt: "",
        videoCredits: 0,
        showImagePreview: false,
        imageUrl: "",
        videoUrl: "",
        videoList: [
        ],
        duration: 5,
        durations: [
          { "text": "5s", "value": 5 },
          { "text": "10s", "value": 10 }
        ],
        ratio: "720:1280",  
        ratios: [
          { "text": "Pionowe", "value": "720:1280" },
          { "text": "Poziome", "value": "1280:720" }
        ],
        selectedCameraStyles: "",
        cameraStyles: [
          { "text": "Brak", "value": "" },
          { "text": "Ujęcie z dołu", "value": "Low angle" },
          { "text": "Ujęcie z góry", "value": "High angle" },
          { "text": "Ujęcie z lotu ptaka", "value": "Overhead" },
          { "text": "Ujęcie z perspektywy pierwszej osoby (FPV)", "value": "FPV" },
          { "text": "Z ręki", "value": "Hand held" },
          { "text": "Szerokokątny obiektyw", "value": "Wide angle" },
          { "text": "Zbliżenie", "value": "Close up" },
          { "text": "Makro filmowanie", "value": "Macro cinematography" },
          { "text": "Zza ramienia", "value": "Over the shoulder" },
          { "text": "Śledzące ujęcie", "value": "Tracking" },
          { "text": "Ujęcie wprowadzające", "value": "Establishing wide" },
          { "text": "Obiektyw 50mm", "value": "50mm lens" },
          { "text": "Kamera przytwierdzona do ciała (SnorriCam)", "value": "SnorriCam" },
          { "text": "Realistyczny styl dokumentalny", "value": "Realistic documentary" },
          { "text": "Kamera amatorska (Camcorder)", "value": "Camcorder" },
          { "text": "Skośne ujęcie (Dutch angle)", "value": "Dutch angle" },
          { "text": "Perspektywa postaci (POV)", "value": "POV" },
          { "text": "Ekstremalne zbliżenie", "value": "Extreme close‑up" },
          { "text": "Ujęcie średnie", "value": "Medium shot" },
          { "text": "Ujęcie dalekie", "value": "Long shot" },
          { "text": "Pełne ujęcie postaci", "value": "Full shot" },
          { "text": "Ujęcie dwóch osób (Two-shot)", "value": "Two‑shot" },
          { "text": "Ujęcie kowbojskie", "value": "Cowboy shot" },
          { "text": "Zza ramienia z przeszkodą (Dirty OTS)", "value": "Dirty over‑the‑shoulder" },
          { "text": "Błyskawiczny ruch kamery (Whip pan)", "value": "Whip pan" },
          { "text": "Ujęcie z gimbala", "value": "Gimbal shot" },
          { "text": "Ujęcie z dolly", "value": "Dolly shot" },
          { "text": "Zoom z dolly", "value": "Dolly zoom" },
          { "text": "Efekt Vertigo", "value": "Vertigo effect" },
          { "text": "Ujęcie z żurawia", "value": "Crane" },
          { "text": "Ujęcie z drona", "value": "Drone aerial shot" }
        ],
        selectedLightStyles: "",
        lightStyles: [
          { "text": "Brak", "value": "" },
          { "text": "Rozproszone światło", "value": "Diffused lighting" },
          { "text": "Sylwetka", "value": "Silhouette" },
          { "text": "Efekt flary obiektywu", "value": "Lens flare" },
          { "text": "Podświetlenie z tyłu", "value": "Back lit" },
          { "text": "Oświetlenie boczne", "value": "Side lit" },
          { "text": "Oświetlenie żaluzjowe", "value": "Venetian lighting" },
          { "text": "Twarde światło", "value": "Hard light" },
          { "text": "Oświetlenie z góry", "value": "Top light" },
          { "text": "Oświetlenie od dołu", "value": "Under‑lighting" },
          { "text": "Światło grozy", "value": "Horror light" },
          { "text": "Oświetlenie Rembrandta", "value": "Rembrandt lighting" },
          { "text": "Światło kontrowe (kicker)", "value": "Kicker light" },
          { "text": "Światło obrysowe (rim)", "value": "Rim" },
          { "text": "Styl świecowy", "value": "Candlelight style" },
          { "text": "Styl ogniskowy", "value": "Firelight style" },
          { "text": "Niebieski blask księżyca", "value": "Moonlight blue" },
          { "text": "Pomarańcz sodowy", "value": "Sodium‑vapor orange" },
          { "text": "Neonowe światło", "value": "Neon‑glow lighting" },
          { "text": "Kontrastowe światło noir", "value": "High‑contrast noir lighting" },
          { "text": "Poświata telewizora", "value": "TV glow lighting" },
          { "text": "Poświata monitora", "value": "Monitor glow" },
          { "text": "Błyskawica", "value": "Lightning‑flash lighting" },
          { "text": "Światło krzyżowe", "value": "Cross‑lighting" },
          { "text": "Światło odbite (wypełniające)", "value": "Bounce‑fill lighting" },
          { "text": "Promień przez mgłę", "value": "Fog‑beam" },
          { "text": "Portret z lampą pierścieniową", "value": "Ring‑light portrait" },
          { "text": "Ciepłe światło żarowe", "value": "Tungsten warm wash" },
          { "text": "Chłodne światło dzienne", "value": "Daylight cool wash" },
          { "text": "Złota godzina", "value": "Golden‑hour glow" }
        ],
        selectedCameraMovments: "",
        cameraMovments: [
          { "text": "Brak", "value": "" },
          { "text": "Dynamiczny ruch", "value": "Dynamic motion" },
          { "text": "Zwolnione tempo", "value": "Slow motion" },
          { "text": "Przyspieszone tempo", "value": "Fast motion" },
          { "text": "Timelapse (przyspieszony zapis czasu)", "value": "Timelapse" }
        ],
        selectedTransformsStyles: "",
        transformsStyles:[
          { "text": "Brak", "value": "" },
          { "text": "Wzrasta", "value": "Grows" },
          { "text": "Wyłania się", "value": "Emerges" },
          { "text": "Eksploduje", "value": "Explodes" },
          { "text": "Wznosi się", "value": "Ascends" },
          { "text": "Faluje", "value": "Undulates" },
          { "text": "Zniekształca się", "value": "Warps" },
          { "text": "Transformuje się", "value": "Transforms" },
          { "text": "Rozchodzi się falami", "value": "Ripples" },
          { "text": "Roztrzaskuje się", "value": "Shatters" },
          { "text": "Rozwija się", "value": "Unfolds" },
          { "text": "Wiruje (wir)", "value": "Vortex" }
        ],
        selectedMovieStyles: "",
        movieStyles:[
          { "text": "Brak", "value": "" },
          { "text": "Nastrojowy", "value": "Moody" },
          { "text": "Filmowy", "value": "Cinematic" },
          { "text": "Irydyscentny", "value": "Iridescent" },
          { "text": "Domowe nagranie VHS", "value": "Home video VHS" },
          { "text": "Glitchcore", "value": "Glitchcore" },
          { "text": "Klasyczny film noir", "value": "Film noir klasyczny" },
          { "text": "Nowoczesny neo-noir", "value": "Neo‑noir nowoczesny" },
          { "text": "Retro Technicolor", "value": "Technicolor retro" },
          { "text": "Grindhouse", "value": "Grindhouse" },
          { "text": "Kwasowe lata 90.", "value": "Acid‑wash 90s" },
          { "text": "Pastelowa estetyka à la Wes Anderson", "value": "Pastel‑core à la Wes Anderson" },
          { "text": "Ziarnisty dokument 16 mm", "value": "Grainy 16 mm documentary" },
          { "text": "Bleach bypass", "value": "Bleach bypass" },
          { "text": "Cross-processed vintage", "value": "Cross‑processed vintage" },
          { "text": "Anamorficzne flary", "value": "Anamorficzne flary" },
          { "text": "Cyberpunk neon", "value": "Cyberpunk neon" },
          { "text": "Synthwave z neonową poświatą", "value": "Synthwave vapor glow" },
          { "text": "Retro-futurystyczny chrom", "value": "Retro‑futuristic chrome" },
          { "text": "Sepia z ery kina niemego", "value": "Sepia silent‑era" },
          { "text": "Wysoki kontrast – chiaroscuro", "value": "High‑contrast chiaroscuro" },
          { "text": "Minimalizm monochromatyczny", "value": "Monochrome minimal" },
          { "text": "Duotone pop-art", "value": "Duotone pop‑art" },
          { "text": "Styl filmu domowego Super 8", "value": "Super 8 home‑movie look" },
          { "text": "Ultra-nasycony kolor pop", "value": "Ultra‑saturated pop color" },
          { "text": "Odbarwiony styl „Szeregowca Ryana”", "value": "Desaturated „Saving Private Ryan” look" },
          { "text": "Wypalony żar pustyni", "value": "Bleached desert heat‑haze" },
          { "text": "Blokbasterowy teal-and-orange", "value": "Teal‑and‑orange blockbuster" },
          { "text": "Senny krajobraz w podczerwieni", "value": "Infrared dreamscape" },
          { "text": "Thriller w termowizji", "value": "Thermal‑vision thriller" },
          { "text": "Polaroidowy film natychmiastowy", "value": "Polaroid instant film" },
          { "text": "Lomografia z przeciekami światła", "value": "Lomography light‑leaks" },
          { "text": "Winieta z zabawkowej kamery", "value": "“Toy‑camera” vignette" },
          { "text": "Tilt-shift – świat w miniaturze", "value": "Tilt‑shift miniature‑world" },
          { "text": "Telewizja lat 70. – grind TV", "value": "70s grind‑TV broadcast" },
          { "text": "Ekran retro ze skanowaniem CRT", "value": "CRT scanline retro‑screen" },
          { "text": "Estetyka pikselowa 8-bit", "value": "Pixel‑art 8‑bit aesthetic" },
          { "text": "Ziarnistość wysokiego ISO w nocy", "value": "High‑ISO night‑grit" },
          { "text": "Epickie pejzaże z drona", "value": "Drone‑aerial epic vistas" },
          { "text": "Jasna biel – high-key", "value": "Snow‑white high‑key" },
          { "text": "Gotycki, deszczowy mrok", "value": "Gothic deszczowy mrok" },
          { "text": "Eteryczna mgła pastelowa", "value": "Ethereal pastel‑fog" },
          { "text": "Pryzmatyczne załamanie światła", "value": "Prismatic light‑splits" },
          { "text": "Poświata wypalenia taśmy filmowej", "value": "Halation film‑burn glow" },
          { "text": "Senna akwarela", "value": "Watercolor‑filter dream" },
          { "text": "Styl komiksowy z cieniowaniem cel", "value": "Graphic‑novel cel‑shaded" },
          { "text": "Neo-barokowy ornament", "value": "Neo‑baroque ornament" },
          { "text": "Desert noir – Dustcore", "value": "Desert noir Dustcore" },
          { "text": "Steampunk – sepia i miedź", "value": "Steampunk sepia‑copper" },
          { "text": "Bioluminescencyjne kolory nocy", "value": "Bio‑luminescent night‑color" },
          { "text": "Zniekształcenie z kamery VHS", "value": "VHS‑camcorder glitch‑wash" },
          { "text": "Proporcje 4:3 – nostalgia", "value": "4:3 Academy ratio nostalgia" },
          { "text": "Ultraszerokie ujęcie letterbox", "value": "Letterbox ultra‑wide epic" },
          { "text": "Rotoskopia malowana ręcznie", "value": "Hand‑painted rotoscope" },
          { "text": "Arktyczna chłodna biel i błękit", "value": "Arctic blue‑white chill" },
          { "text": "Retro anime z filtrem ziarnistości", "value": "Retro anime grain‑filter" }
        ],
      }
    },
    methods: {

      validateImageUrl: function(url) {
        if (!url) return false;
        try {
          const imageUrlPattern = /^(https?:\/\/.*\.(?:png|jpg|jpeg|gif|webp|svg))$/i;
          return imageUrlPattern.test(url);
        } catch (error) {
          return false;
        }
      },

      triggerGenerateImage: function() {
 
        if(!this.imagePrompt) {

          this.$bvToast.toast('Podaj prompt do generatora obrazów', {
            title: 'Błąd',
            solid: true,
            toaster: 'b-toaster-top-center',
            variant: 'danger',
          })

          return false;
        }


        this.$refs.triggerGenerateImage.disabled = true
        this.isAiGenImg = true
        this.showImagePreview = false

        var query = "Przetłumacz na angielski: '" + this.imagePrompt + ". Realistyczne, dużo szczegółów, wysoka jakość, 8k, HDR, profesjonalne zdjęcie, wysoka jakość, ostre szczegóły, realistyczne oświetlenie, profesjonalna fotografia, wysoka jakość, ostre szczegóły, realistyczne oświetlenie, profesjonalna fotografia'"; 


        this.axios.post(window.API_URL + "apps/aiPostCreator/getAiText/", { 'text': query }, { withCredentials: true, timeout: 3000000 }).then((response) => {

          let data = response.data

          if(data.redirectTo) {

            top.location.href = data.redirectTo;

          }

          
          this.axios.post(window.API_URL + "apps/graphicAi/paintn2/", { 'prompt': data.result }, { withCredentials: true, timeout: 320000 }).then((response2) => {

            let data = response2.data
  
                this.axios.post("https://instastorage.net/b642png.php", 
                { 'image': String(data.result) }, 
                { 
                  headers: { 'Content-Type': 'application/json' }, 
                  withCredentials: true, 
                  timeout: 320000 
                }).then((response3) => {

                   if(response3.data.url)
                    this.imageUrl = response3.data.url

                    this.$refs.triggerGenerateImage.disabled = false

                    this.windowImageGeneration = false

                    this.isAiGenImg = false

                }).catch(function() {

                  this.$refs.triggerGenerateImage.disabled = false

                  this.isAiGenImg = false

                });
            
         
          }).catch(function() {

            this.$refs.triggerGenerateImage.disabled = false

            this.isAiGenImg = false
           
          });


        }).catch(function() {

          this.$refs.triggerGenerateImage.disabled = false

          this.isAiGenImg = false

        })


      },


      getVideos: function() {

        this.axios.get(window.API_URL + "apps/checkVideos",   { withCredentials: true, timeout: 3000000 }).then((response) => {

          let data = response.data

          if(data.redirectTo) {

            top.location.href = data.redirectTo;

          }

          this.axios.get(window.API_URL + "apps/getVideos",   { withCredentials: true, timeout: 3000000 }).then((response) => {

          let data = response.data

          if(data.redirectTo) {

            top.location.href = data.redirectTo;

          }

          this.videoList = data

          }).catch(function() {

          })
         
        }).catch(function() {

        })
 
      },
      
      loadVideoCredits: function() {

        this.axios.get(window.API_URL + "apps/loadVideoCredits",   { withCredentials: true, timeout: 3000000 }).then((response) => {

          let data = response.data

          if(data.redirectTo) {

            top.location.href = data.redirectTo;

          }

          this.videoCredits = data.videoCredits
 
        }).catch(function() {

        })

        

      },

      generateFinish: function() {
 
        if(!this.imageUrl) {

          this.$bvToast.toast('Dodaj obraz startowy, albo stwórz nowy z AI', {
            title: 'Błąd',
            solid: true,
            toaster: 'b-toaster-top-center',
            variant: 'danger',
          })

          return false;
        }

        if(!this.prompt) {
          
          this.$bvToast.toast('Podaj prompt do video', {
            title: 'Błąd',
            solid: true,
            toaster: 'b-toaster-top-center',
            variant: 'danger',
          })

          return false;
        }
        
        this.isAiGenVideo = true

        this.showImagePreview = false
        this.videoUrl = ''
        this.$refs.generatePost.disabled = true
        
        this.result = ""
        
        var query = this.prompt;
      
        if(this.selectedCameraStyles) query += ". Styl kamery: " + this.selectedCameraStyles;
        if(this.selectedLightStyles) query += ". Styl oświetlenia: " + this.selectedLightStyles;
        if(this.selectedCameraMovments) query += ". Ruch kamery: " + this.selectedCameraMovments;
        if(this.selectedTransformsStyles) query += ". Styl transformacji: " + this.selectedTransformsStyles;
        if(this.selectedMovieStyles) query += ". Styl filmu: " + this.selectedMovieStyles;
        
 
        query = "Przetłumacz na angielski: '" + query + "'"; 
  
        this.axios.post(window.API_URL + "apps/logVideo/", { 'prompt': this.prompt, 'img': this.imageUrl }, { withCredentials: true, timeout: 3000000 });
  

 
        this.axios.post(window.API_URL + "apps/aiPostCreator/getAiText/", { 'text': query }, { withCredentials: true, timeout: 3000000 }).then((response) => {
  
          let data = response.data
    
          if(data.redirectTo) {

            top.location.href = data.redirectTo;

          }

        
          this.axios.post(window.API_URL + "apps/generateVideo", { 'prompt': data.result, 'image': this.imageUrl, 'duration': this.duration, 'ratio': this.ratio }, { withCredentials: true, timeout: 3000000 }).then((response) => {

            let data = response.data
            
            if(data.redirectTo) {

              top.location.href = data.redirectTo;

            }
            
            window.scrollTo(0, 0);

            this.$bvToast.toast('Utworzone video znajdzie się na liście po prawej stronie', {
              title: 'OK',
              solid: true,
              toaster: 'b-toaster-top-center',
              variant: 'success',
            })

            this.loadVideoCredits()
              

            this.$refs.generatePost.disabled = false
            this.isAiGenVideo = false

          }).catch(function() {

            this.$refs.generatePost.disabled = false
            this.isAiGenVideo = false

          })

        });

 
      },

      handleFileUpload: function(event) {

        const file = event.target.files[0];
        
        this.uploadedFileUrl = "";
        this.showImagePreview = false

        if (file) {
 
          const formData = new FormData();

          formData.append('file', file);

          const headers = {'Content-Type': 'multipart/form-data'};

          this.axios.post("https://soft.funnelstar.io/api/images/upload/", formData, {
            withCredentials: true,
            headers
          }).then((response) => {

            let data = response.data

            this.uploadedFileUrl = data.file

            if (this.uploadedFileUrl) {

              this.imageUrl = this.uploadedFileUrl

            }

            this.$refs.fileInput.value = null;

          }).catch(function () {

             

          });


        }  

      },

      triggerFileUpload: function() {
        this.$refs.fileInput.click();
      },

      

    },
    computed: {
  
    },
    created() {

      this.getVideos()
      this.loadVideoCredits()

      setInterval(() => {
        this.getVideos()
      }, 5000)
 
    },
    mounted() {

      if (localStorage.generators_language) {

        this.lang = localStorage.generators_language;

      } else {

        localStorage.generators_language = "Polski"
        this.lang = "Polski"
      }

    },
    watch: {

      lang(data) {

        localStorage.generators_language = data;

      },

    }

  }
</script>

<style>

  .pointer { cursor: pointer; }
  .bold { font-weight: 600 !important; }
  code { color: #4e82f7 !important; }
 
      @keyframes rotate {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
      }

      .rotating {
        display: inline-block;
        animation: rotate 2s linear infinite;
      }
    </style>